import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import {
  Button,
  Form,
  Modal,
  Table,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Image,
} from 'react-bootstrap';

import { areYouSure } from 'lib/utils/toast';
import VerificationStatusIcon from 'components/global_products/detail_view/VerificationStatusIcon';

function ProductsLinksSuggestionsModal({
  selectedManufacturerProducts,
  selectedVendorProducts,
  linkProducts,
  setSelectedManufacturerProducts,
  setSelectedVendorProducts,
  onHide,
  getProductImageUrl,
}) {
  const [selectedManufacturerProduct, setSelectedManufacturerProduct] = useState(null);
  const [selectedVendorProduct, setSelectedVendorProduct] = useState(null);

  return (
    <Modal show={true} onHide={onHide} dialogClassName={css(styles.largeModalDialog)}>
      <Modal.Header closeButton>
        <div className="d-flex flex-column">
          <Modal.Title className="mont">
            <h2 className="font-weight-bold">Select the primary product</h2>
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        {selectedManufacturerProducts.length > 0 && (
          <>
            <span className="font-weight-bold ml-4 mb-2">
              Select the primary manufacturer Product
            </span>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th width="5px"></th>
                  <th width="180px">Manufacturer SKU</th>
                  <th width="450px">Name</th>
                  <th width="150px">GTIN</th>
                  <th width="200">Brand</th>
                  <th width="200px">Manufacturer</th>
                  <th width="200px">L4 Category</th>
                  <th width="100px">Pack Size</th>
                  <th width="100px">FSA Score</th>
                  <th width="100px">Verification Status</th>
                </tr>
              </thead>
              <tbody>
                {selectedManufacturerProducts.map(product => (
                  <tr key={product.id}>
                    <td>
                      <Form.Check
                        type="radio"
                        name="manufacturerProductSelection"
                        checked={selectedManufacturerProduct?.id === product.id}
                        onChange={e => {
                          if (e.target.checked) {
                            setSelectedManufacturerProduct(product);
                          }
                        }}
                      />
                    </td>
                    <td>
                      {product.manufacturer_product.global_product_id}
                      {' | '}
                      <a
                        href={
                          '/global-product-detail/' +
                          product.manufacturer_product.global_product.id +
                          '/' +
                          product.manufacturer_product.id +
                          '/manufacturer'
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {product.manufacturer_product?.manufacturer_sku}
                      </a>
                    </td>
                    <td>
                      <Row>
                        <Col sm={2}>
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Popover id="popover-basic" style={{ maxWidth: 400 }}>
                                <Popover.Content>
                                  <Image width={400} fluid src={getProductImageUrl(product)} />
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <Image width={50} fluid src={getProductImageUrl(product)} thumbnail />
                          </OverlayTrigger>
                        </Col>
                        <Col>{product.manufacturer_product?.name}</Col>
                      </Row>
                    </td>
                    <td>{product.manufacturer_product?.gtin || '-'}</td>
                    <td>{product.manufacturer_product?.brand?.name || '-'}</td>
                    <td>{product.manufacturer_product?.global_manufacturer?.name || '-'}</td>
                    <td>
                      {product.manufacturer_product?.global_product?.l4_category?.category_name ||
                        '-'}
                    </td>
                    <td>{product.manufacturer_product?.pack_size || '-'}</td>
                    <td>{product.manufacturer_product?.fsa_score || '-'}</td>
                    <td>
                      <VerificationStatusIcon
                        verificationStatus={product.manufacturer_product?.verification_status}
                        aiSuggestedVerification={false}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
        {selectedVendorProducts.length > 0 && (
          <>
            <span className="font-weight-bold ml-4 mb-2">Vendor Products that will be linked</span>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th width="5px"></th>
                  <th width="180px">Vendor SKU</th>
                  <th width="500px">Name</th>
                  <th width="150px">GTIN</th>
                  <th width="250px">Brand</th>
                  <th width="250px">Manufacturer</th>
                  <th width="200px">L4 Category</th>
                  <th width="100px">Pack Size</th>
                  <th width="100px">FSA Score</th>
                  <th width="100px">Verification Status</th>
                </tr>
              </thead>
              <tbody>
                {selectedVendorProducts.map(product => (
                  <tr key={product.id}>
                    <td>
                      {selectedManufacturerProducts.length < 1 ? (
                        <Form.Check
                          type="radio"
                          name="vendorProductSelection"
                          checked={selectedVendorProduct?.id === product.id}
                          onChange={e => {
                            if (e.target.checked) {
                              setSelectedVendorProduct(product);
                            }
                          }}
                        />
                      ) : null}
                    </td>
                    <td>
                      {product.vendor_product.global_product_id}
                      {' | '}
                      <a
                        href={
                          '/global-product-detail/' +
                          product.vendor_product.global_product.id +
                          '/' +
                          product.vendor_product.id +
                          '/distributor'
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {product.vendor_product.vendor_sku}
                      </a>
                      <br />
                      <span className="text-muted">
                        {product.vendor_product.global_vendor.name}
                      </span>
                    </td>
                    <td>
                      <Row>
                        <Col sm={2}>
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Popover id="popover-basic" style={{ maxWidth: 400 }}>
                                <Popover.Content>
                                  <Image
                                    width={400}
                                    fluid
                                    src={getProductImageUrl(product, true)}
                                  />
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <Image
                              width={50}
                              fluid
                              src={getProductImageUrl(product, true)}
                              thumbnail
                            />
                          </OverlayTrigger>
                        </Col>
                        <Col>{product.vendor_product.name}</Col>
                      </Row>
                    </td>
                    <td>{product.vendor_product.gtin || '-'}</td>
                    <td>{product.vendor_product.brand.name || '-'}</td>
                    <td>{product.vendor_product.brand.global_manufacturer.name || '-'}</td>
                    <td>
                      {product.vendor_product.global_product?.l4_category?.category_name || '-'}
                    </td>
                    <td>{product.vendor_product.pack_size || '-'}</td>
                    <td>{product.vendor_product.fsa_score || '-'}</td>
                    <td>
                      <VerificationStatusIcon
                        verificationStatus={product.vendor_product?.verification_status}
                        aiSuggestedVerification={false}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() =>
            areYouSure(
              () => {
                linkProducts({
                  primary_manufacturer_product_id:
                    selectedManufacturerProduct.manufacturer_product.id,
                  vendor_product_ids_to_merge: selectedVendorProducts.map(
                    product => product.vendor_product.id,
                  ),
                  manufacturer_product_ids_to_merge: selectedManufacturerProducts
                    .filter(product => product.id !== selectedManufacturerProduct.id)
                    .map(product => product.manufacturer_product.id),
                  ids_to_hide: [
                    ...selectedManufacturerProducts.map(product => product.id),
                    ...selectedVendorProducts.map(product => product.id),
                  ],
                });
                setSelectedManufacturerProducts([]);
                setSelectedVendorProducts([]);
                onHide();
              },
              'Are you sure you want to link the selected products?',
              'Link Products',
            )
          }
          disabled={selectedManufacturerProduct === null}
        >
          Link Products
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const styles = StyleSheet.create({
  largeModalDialog: {
    maxWidth: '90vw',
    width: '90vw',
    margin: '1.75rem auto',
  },
});

ProductsLinksSuggestionsModal.propTypes = {
  selectedManufacturerProducts: PropTypes.array,
  selectedVendorProducts: PropTypes.array,
  linkProducts: PropTypes.func,
  setSelectedManufacturerProducts: PropTypes.func,
  setSelectedVendorProducts: PropTypes.func,
  onHide: PropTypes.func,
  getProductImageUrl: PropTypes.func,
};

export default ProductsLinksSuggestionsModal;
